/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScoringStrategy } from './ScoringStrategy';
import {
    ScoringStrategyFromJSON,
    ScoringStrategyFromJSONTyped,
    ScoringStrategyToJSON,
    ScoringStrategyToJSONTyped,
} from './ScoringStrategy';
import type { ArenaRangeConfig } from './ArenaRangeConfig';
import {
    ArenaRangeConfigFromJSON,
    ArenaRangeConfigFromJSONTyped,
    ArenaRangeConfigToJSON,
    ArenaRangeConfigToJSONTyped,
} from './ArenaRangeConfig';
import type { ChallengeFeeStructure } from './ChallengeFeeStructure';
import {
    ChallengeFeeStructureFromJSON,
    ChallengeFeeStructureFromJSONTyped,
    ChallengeFeeStructureToJSON,
    ChallengeFeeStructureToJSONTyped,
} from './ChallengeFeeStructure';
import type { ArenaScoringMode } from './ArenaScoringMode';
import {
    ArenaScoringModeFromJSON,
    ArenaScoringModeFromJSONTyped,
    ArenaScoringModeToJSON,
    ArenaScoringModeToJSONTyped,
} from './ArenaScoringMode';
import type { StrategyConfigs } from './StrategyConfigs';
import {
    StrategyConfigsFromJSON,
    StrategyConfigsFromJSONTyped,
    StrategyConfigsToJSON,
    StrategyConfigsToJSONTyped,
} from './StrategyConfigs';
import type { TargetGoalMode } from './TargetGoalMode';
import {
    TargetGoalModeFromJSON,
    TargetGoalModeFromJSONTyped,
    TargetGoalModeToJSON,
    TargetGoalModeToJSONTyped,
} from './TargetGoalMode';

/**
 * Arena game configuration with per-strategy settings
 * @export
 * @interface ArenaGameConfig
 */
export interface ArenaGameConfig {
    /**
     * Which scoring strategies are allowed for Arena challenges
     * @type {Array<ScoringStrategy>}
     * @memberof ArenaGameConfig
     */
    allowedStrategies?: Array<ScoringStrategy>;
    /**
     * 
     * @type {ScoringStrategy}
     * @memberof ArenaGameConfig
     */
    defaultStrategy?: ScoringStrategy;
    /**
     * 
     * @type {ArenaRangeConfig}
     * @memberof ArenaGameConfig
     */
    entryFeeRange?: ArenaRangeConfig;
    /**
     * Quick-select entry fee tiers
     * @type {Array<number>}
     * @memberof ArenaGameConfig
     */
    presetEntryFees?: Array<number>;
    /**
     * 
     * @type {ArenaRangeConfig}
     * @memberof ArenaGameConfig
     */
    targetGoalRange?: ArenaRangeConfig;
    /**
     * 
     * @type {TargetGoalMode}
     * @memberof ArenaGameConfig
     */
    defaultTargetGoalMode?: TargetGoalMode;
    /**
     * 
     * @type {StrategyConfigs}
     * @memberof ArenaGameConfig
     */
    strategyConfigs?: StrategyConfigs;
    /**
     * 
     * @type {ArenaScoringMode}
     * @memberof ArenaGameConfig
     */
    arenaScoringMode?: ArenaScoringMode;
    /**
     * How entry fee values are interpreted — raw FUEL token quantities (QTY) or USD amounts converted to FUEL at runtime (USD_EQUIVALENT).
     * @type {string}
     * @memberof ArenaGameConfig
     */
    fuelPricingMode?: ArenaGameConfigFuelPricingModeEnum;
    /**
     * Platform fee percentage (0-50%) applied to arena challenges for this game.
     * @type {number}
     * @memberof ArenaGameConfig
     */
    platformFeePercent?: number;
    /**
     * 
     * @type {ChallengeFeeStructure}
     * @memberof ArenaGameConfig
     */
    feeStructure?: ChallengeFeeStructure;
}


/**
 * @export
 */
export const ArenaGameConfigFuelPricingModeEnum = {
    QTY: 'QTY',
    USD_EQUIVALENT: 'USD_EQUIVALENT'
} as const;
export type ArenaGameConfigFuelPricingModeEnum = typeof ArenaGameConfigFuelPricingModeEnum[keyof typeof ArenaGameConfigFuelPricingModeEnum];


/**
 * Check if a given object implements the ArenaGameConfig interface.
 */
export function instanceOfArenaGameConfig(value: object): value is ArenaGameConfig {
    return true;
}

export function ArenaGameConfigFromJSON(json: any): ArenaGameConfig {
    return ArenaGameConfigFromJSONTyped(json, false);
}

export function ArenaGameConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArenaGameConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'allowedStrategies': json['allowedStrategies'] == null ? undefined : ((json['allowedStrategies'] as Array<any>).map(ScoringStrategyFromJSON)),
        'defaultStrategy': json['defaultStrategy'] == null ? undefined : ScoringStrategyFromJSON(json['defaultStrategy']),
        'entryFeeRange': json['entryFeeRange'] == null ? undefined : ArenaRangeConfigFromJSON(json['entryFeeRange']),
        'presetEntryFees': json['presetEntryFees'] == null ? undefined : json['presetEntryFees'],
        'targetGoalRange': json['targetGoalRange'] == null ? undefined : ArenaRangeConfigFromJSON(json['targetGoalRange']),
        'defaultTargetGoalMode': json['defaultTargetGoalMode'] == null ? undefined : TargetGoalModeFromJSON(json['defaultTargetGoalMode']),
        'strategyConfigs': json['strategyConfigs'] == null ? undefined : StrategyConfigsFromJSON(json['strategyConfigs']),
        'arenaScoringMode': json['arenaScoringMode'] == null ? undefined : ArenaScoringModeFromJSON(json['arenaScoringMode']),
        'fuelPricingMode': json['fuelPricingMode'] == null ? undefined : json['fuelPricingMode'],
        'platformFeePercent': json['platformFeePercent'] == null ? undefined : json['platformFeePercent'],
        'feeStructure': json['feeStructure'] == null ? undefined : ChallengeFeeStructureFromJSON(json['feeStructure']),
    };
}

export function ArenaGameConfigToJSON(json: any): ArenaGameConfig {
    return ArenaGameConfigToJSONTyped(json, false);
}

export function ArenaGameConfigToJSONTyped(value?: ArenaGameConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowedStrategies': value['allowedStrategies'] == null ? undefined : ((value['allowedStrategies'] as Array<any>).map(ScoringStrategyToJSON)),
        'defaultStrategy': ScoringStrategyToJSON(value['defaultStrategy']),
        'entryFeeRange': ArenaRangeConfigToJSON(value['entryFeeRange']),
        'presetEntryFees': value['presetEntryFees'],
        'targetGoalRange': ArenaRangeConfigToJSON(value['targetGoalRange']),
        'defaultTargetGoalMode': TargetGoalModeToJSON(value['defaultTargetGoalMode']),
        'strategyConfigs': StrategyConfigsToJSON(value['strategyConfigs']),
        'arenaScoringMode': ArenaScoringModeToJSON(value['arenaScoringMode']),
        'fuelPricingMode': value['fuelPricingMode'],
        'platformFeePercent': value['platformFeePercent'],
        'feeStructure': ChallengeFeeStructureToJSON(value['feeStructure']),
    };
}

